module.exports = __webpack_public_path__ + "images/category_lp/hobby/assessment_achievements/3@2x_84bd35f439be215d9602c081af655b64.png";